// extracted by mini-css-extract-plugin
export default {"tr":"communicationTableRow_tr__Dxnyd","td":"communicationTableRow_td__OQocY"};